(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-navratri-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-pd-festive-bar]';
    const instances = new WeakMap();

    function indiaToday() {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      const get = key => parts.find(p => p.type === key)?.value || '00';
      return `${get('year')}-${get('month')}-${get('day')}`;
    }

    function validIsoDate(value) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
      const ms = Date.parse(`${value}T00:00:00Z`);
      return Number.isFinite(ms) && new Date(ms).toISOString().slice(0, 10) === value;
    }

    function isLightBackground(color) {
      let hex = String(color || '').trim().replace('#', '');
      if (/^[a-f0-9]{3}$/i.test(hex)) hex = hex.split('').map(c => c + c).join('');
      if (!/^[a-f0-9]{6}$/i.test(hex)) return false;
      const parts = [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16) / 255);
      const channels = parts.map(v => v <= .04045 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4));
      const luminance = .2126 * channels[0] + .7152 * channels[1] + .0722 * channels[2];
      return luminance >= .43;
    }

    function getPhase(root) {
      const mode = root.dataset.mode;
      if (mode === 'off') return 'off';
      if (mode === 'manual') return root.dataset.manualPhase || 'day1';
      const date = indiaToday();
      const prelaunch = root.dataset.prelaunchDate;
      const start = root.dataset.startDate;
      const end = root.dataset.endDate;
      const dussehra = root.dataset.dussehraDate;
      if (![prelaunch, start, end, dussehra].every(validIsoDate)) return 'off';
      if (date === dussehra) return 'dussehra';
      if (date >= start && date <= end) {
        const days = Math.round((Date.parse(`${date}T00:00:00Z`) - Date.parse(`${start}T00:00:00Z`)) / 86400000);
        return `day${Math.min(days + 1, 9)}`;
      }
      if (date >= prelaunch && date < start) return 'prelaunch';
      return 'off';
    }

    function install(root) {
      if (instances.has(root)) instances.get(root).destroy();
      const slides = Array.from(root.querySelectorAll('[data-pd-slide]'));
      const prev = root.querySelector('[data-pd-step="-1"]');
      const next = root.querySelector('[data-pd-step="1"]');
      const status = root.querySelector('[data-pd-status]');
      const controller = new AbortController();
      let phase = null;
      let previewBlock = null;
      let visible = [];
      let currentIndex = 0;
      let rotationTimer = null;
      let clockTimer = null;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const rotateMs = Math.max(3000, Number(root.dataset.rotateMs) || 5000);

      function stopRotation() {
        if (rotationTimer !== null) window.clearInterval(rotationTimer);
        rotationTimer = null;
      }

      function setActive(index, announce) {
        if (!visible.length) return;
        currentIndex = (index + visible.length) % visible.length;
        const selected = visible[currentIndex];
        slides.forEach(slide => {
          const active = slide === selected;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        if (announce && status) {
          status.textContent = `Announcement ${currentIndex + 1} of ${visible.length}: ${selected.innerText.trim()}`;
        }
      }

      function canRotate() {
        if (root.dataset.rotate !== 'true' || visible.length < 2 || previewBlock) return false;
        if (document.hidden) return false;
        if (root.dataset.pauseHover === 'true' && (root.matches(':hover') || root.contains(document.activeElement))) return false;
        return true;
      }

      function startRotation() {
        stopRotation();
        if (root.dataset.rotate !== 'true' || visible.length < 2 || previewBlock || reducedMotion.matches) return;
        rotationTimer = window.setInterval(() => {
          if (canRotate()) setActive(currentIndex + 1, false);
        }, rotateMs);
      }

      function refresh(nextPhase) {
        phase = nextPhase;
        const preferredId = visible[currentIndex]?.dataset.pdBlockId;
        if (previewBlock) {
          visible = slides.filter(slide => slide.dataset.pdBlockId === previewBlock);
        } else {
          visible = slides.filter(slide => {
            if (slide.dataset.enabled !== 'true') return false;
            const scope = slide.dataset.scope;
            return scope === phase || (scope === 'navratri' && /^day[1-9]$/.test(phase)) || (scope === 'all_active' && phase !== 'off');
          });
        }
        root.hidden = visible.length === 0;
        const previewScope = previewBlock && visible[0] ? visible[0].dataset.scope : null;
        const accentPhase = /^day[1-9]$/.test(previewScope || '') ? previewScope : phase;
        
        const scheduledBg = root.getAttribute(`data-bg-${accentPhase}`) || root.dataset.bgDefault;
        const background = root.dataset.dayBackground === 'true' ? scheduledBg : root.dataset.bgDefault;
        const light = isLightBackground(background);

        const customText = root.getAttribute(`data-text-${accentPhase}`);
        const customOrnament = root.getAttribute(`data-ornament-${accentPhase}`);

        const textColor = customText && customText.trim() !== '' ? customText : (light ? root.dataset.textDefaultDark : root.dataset.textDefaultLight);
        const ornamentColor = customOrnament && customOrnament.trim() !== '' ? customOrnament : (light ? root.dataset.ornamentDefaultLight : root.dataset.ornamentDefaultDark);

        root.style.setProperty('--pd-bar-bg', background);
        root.style.setProperty('--pd-bar-fg', textColor);
        root.style.setProperty('--pd-bar-ornament', ornamentColor);
        root.classList.toggle('pd-festive-bar--light', light);
        root.dataset.activePhase = accentPhase;
        const chosen = preferredId ? visible.findIndex(slide => slide.dataset.pdBlockId === preferredId) : -1;
        setActive(chosen >= 0 ? chosen : 0, false);
        if (status) status.textContent = '';
        const showArrows = visible.length > 1 && root.dataset.showArrows === 'true' && !previewBlock;
        if (prev) prev.hidden = !showArrows;
        if (next) next.hidden = !showArrows;
        startRotation();
      }

      root.addEventListener('click', event => {
        const button = event.target.closest('[data-pd-step]');
        if (!button || !root.contains(button) || visible.length <= 1) return;
        const amount = Number(button.dataset.pdStep) || 1;
        setActive(currentIndex + amount, true);
        startRotation();
      }, { signal: controller.signal });

      const onReduceChange = () => startRotation();
      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onReduceChange, { signal: controller.signal });

      refresh(getPhase(root));
      clockTimer = window.setInterval(() => {
        if (previewBlock) return;
        const nextPhase = getPhase(root);
        if (nextPhase !== phase) refresh(nextPhase);
      }, 30000);

      const api = {
        selectBlock(id) { previewBlock = id; refresh(getPhase(root)); },
        deselectBlock() { previewBlock = null; refresh(getPhase(root)); },
        destroy() {
          stopRotation();
          if (clockTimer !== null) window.clearInterval(clockTimer);
          controller.abort();
          if (reducedMotion.removeEventListener) reducedMotion.removeEventListener('change', onReduceChange);
          instances.delete(root);
        }
      };
      instances.set(root, api);
    }

    function initializeAll(scope) {
      if (scope.matches && scope.matches(selector)) install(scope);
      scope.querySelectorAll(selector).forEach(install);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    else initializeAll(document);

    document.addEventListener('shopify:section:load', event => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', event => {
      const roots = event.target.matches?.(selector) ? [event.target] : Array.from(event.target.querySelectorAll(selector));
      roots.forEach(root => instances.get(root)?.destroy());
    });
    document.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest?.('[data-pd-slide]');
      const root = slide?.closest(selector);
      if (root && instances.has(root)) instances.get(root).selectBlock(slide.dataset.pdBlockId);
    });
    document.addEventListener('shopify:block:deselect', event => {
      const root = event.target.closest?.(selector);
      if (root && instances.has(root)) instances.get(root).deselectBlock();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-navratri-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-pd-hero]';
  const active = new WeakMap();
  const dateFmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year:'numeric', month:'2-digit', day:'2-digit' });

  function todayIndia() {
    const data = {};
    dateFmt.formatToParts(new Date()).forEach(p => { if (p.type !== 'literal') data[p.type] = p.value; });
    return `${data.year}-${data.month}-${data.day}`;
  }
  function isoDay(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const timestamp = Date.parse(`${value}T00:00:00Z`);
    return Number.isNaN(timestamp) || new Date(timestamp).toISOString().slice(0,10) !== value ? null : timestamp / 86400000;
  }
  function currentPhase(root) {
    const mode = root.dataset.mode;
    if (mode === 'off') return 'off';
    if (mode === 'manual') return root.dataset.manualPhase || 'day1';
    const date = todayIndia();
    const day = isoDay(date);
    const prelaunch = isoDay(root.dataset.prelaunchDate);
    const start = isoDay(root.dataset.startDate);
    const end = isoDay(root.dataset.endDate);
    if (date === root.dataset.dussehraDate) return 'dussehra';
    if (day !== null && start !== null && end !== null && day >= start && day <= end) {
      const number = day - start + 1;
      return number >= 1 && number <= 9 ? `day${number}` : 'off';
    }
    if (day !== null && prelaunch !== null && start !== null && day >= prelaunch && day < start) return 'prelaunch';
    return 'off';
  }
  function darkOn(hex) {
    const value = (hex || '').replace('#', '').trim();
    if (!/^[\da-f]{6}$/i.test(value)) return false;
    const c = [0,2,4].map(i => parseInt(value.slice(i,i+2), 16) / 255);
    const rgb = c.map(v => v <= .04045 ? v / 12.92 : Math.pow((v+.055)/1.055, 2.4));
    return (rgb[0]*.2126 + rgb[1]*.7152 + rgb[2]*.0722) > .27;
  }
  function install(root) {
    if (active.has(root)) return;
    let previewPhase = null, renderedPhase = null;
    const blocks = [...root.querySelectorAll('[data-pd-hero-panel]')];
    function render() {
      const phase = previewPhase || currentPhase(root);
      if (renderedPhase === phase) return;
      renderedPhase = phase;
      const chosen = blocks.find(b => b.dataset.phase === phase) ||
        (phase.startsWith('day') ? blocks.find(b => b.dataset.phase === 'all_days') : null);
      if (phase === 'off' || !chosen) {
        blocks.forEach(b => { b.hidden = true; b.setAttribute('aria-hidden', 'true'); });
        root.hidden = true;
        return;
      }
      blocks.forEach(b => {
        const shown = b === chosen;
        b.hidden = !shown;
        b.setAttribute('aria-hidden', shown ? 'false' : 'true');
        if (shown) b.querySelectorAll('img').forEach(img => {
          img.loading = 'eager';
          img.fetchPriority = 'high';
        });
      });
      const defaultColor = root.dataset.colorPrelaunch || '#174C36';
      const key = phase === 'prelaunch' ? 'colorPrelaunch' : `color${phase.charAt(0).toUpperCase()}${phase.slice(1)}`;
      const color = root.dataset[key] || defaultColor;
      root.style.setProperty('--pd-hero-day', color);
      const solid = root.dataset.bgStyle === 'solid';
      const textColor = solid
        ? (darkOn(color) ? (root.dataset.textDark || '#203F31') : (root.dataset.textLight || '#FFF9EC'))
        : (root.dataset.textDark || '#203F31');
      root.style.setProperty('--pd-hero-ink', textColor);
      root.dataset.activePhase = phase;
      root.hidden = false;
    }
    render();
    const timer = window.setInterval(render, 30000); // handles midnight in India, including long-open tabs
    const inst = {
      select(p) { previewPhase = p; renderedPhase = null; render(); },
      deselect() { previewPhase = null; renderedPhase = null; render(); },
      destroy() { window.clearInterval(timer); active.delete(root); }
    };
    active.set(root, inst);
  }
  function scan(context) {
    if (context.matches && context.matches(selector)) install(context);
    context.querySelectorAll(selector).forEach(install);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(context), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const roots = event.target.matches?.(selector) ? [event.target] : [...event.target.querySelectorAll(selector)];
    roots.forEach(root => active.get(root)?.destroy());
  });
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest?.('[data-pd-hero-panel]');
    const root = panel?.closest(selector);
    if (root) active.get(root)?.select(panel.dataset.phase);
  });
  document.addEventListener('shopify:block:deselect', event => {
    const root = event.target.closest?.(selector);
    if (root) active.get(root)?.deselect();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-navratri-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-pd-slider]';
  const instances = new WeakMap();
  const dateFmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year:'numeric', month:'2-digit', day:'2-digit' });

  function todayIndia() {
    const data = {};
    dateFmt.formatToParts(new Date()).forEach(p => { if (p.type !== 'literal') data[p.type] = p.value; });
    return `${data.year}-${data.month}-${data.day}`;
  }
  function isoDay(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const timestamp = Date.parse(`${value}T00:00:00Z`);
    return Number.isNaN(timestamp) || new Date(timestamp).toISOString().slice(0,10) !== value ? null : timestamp / 86400000;
  }
  function currentPhase(root) {
    const mode = root.dataset.mode;
    if (mode === 'off') return 'off';
    if (mode === 'manual') return root.dataset.manualPhase || 'prelaunch';
    const date = todayIndia();
    const day = isoDay(date);
    const prelaunch = isoDay(root.dataset.prelaunchDate);
    const start = isoDay(root.dataset.startDate);
    const end = isoDay(root.dataset.endDate);
    if (date === root.dataset.dussehraDate) return 'dussehra';
    if (day !== null && start !== null && end !== null && day >= start && day <= end) {
      const number = day - start + 1;
      return number >= 1 && number <= 9 ? `day${number}` : 'off';
    }
    if (day !== null && prelaunch !== null && start !== null && day >= prelaunch && day < start) return 'prelaunch';
    return 'prelaunch';
  }

  function install(root) {
    if (instances.has(root)) instances.get(root).destroy();
    
    const track = root.querySelector('[data-pd-slider-track]');
    const prevBtn = root.querySelector('[data-pd-slider-prev]');
    const nextBtn = root.querySelector('[data-pd-slider-next]');
    const dotsWrap = root.querySelector('[data-pd-slider-dots]');
    const allSlides = [...root.querySelectorAll('[data-pd-slider-slide]')];
    
    let currentIndex = 0;
    let activeSlides = [];
    let autoPlayTimer = null;
    let previewPhase = null;

    function updateCarousel() {
      if (activeSlides.length === 0) {
        root.hidden = true;
        return;
      }
      root.hidden = false;
      if (currentIndex >= activeSlides.length) currentIndex = 0;
      if (currentIndex < 0) currentIndex = activeSlides.length - 1;

      if (track) {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      }

      if (dotsWrap) {
        const dots = dotsWrap.querySelectorAll('.pd-slider__dot');
        dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === currentIndex);
        });
      }

      const showControls = activeSlides.length > 1;
      if (prevBtn) prevBtn.style.display = showControls ? 'grid' : 'none';
      if (nextBtn) nextBtn.style.display = showControls ? 'grid' : 'none';
      if (dotsWrap) dotsWrap.style.display = showControls ? 'flex' : 'none';
    }

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      activeSlides.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `pd-slider__dot ${idx === 0 ? 'is-active' : ''}`;
        dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
        dot.addEventListener('click', () => {
          currentIndex = idx;
          updateCarousel();
          resetAutoplay();
        });
        dotsWrap.appendChild(dot);
      });
    }

    function refresh() {
      const phase = previewPhase || currentPhase(root);
      
      activeSlides = allSlides.filter(b => {
        const p = b.dataset.phase;
        return p === phase || (phase.startsWith('day') && p === 'all_days') || p === 'prelaunch';
      });

      if (activeSlides.length === 0 && allSlides.length > 0) {
        activeSlides = allSlides.slice(0, 2);
      }

      activeSlides.sort((a, b) => {
        const typeA = a.dataset.slideType || 'day_banner';
        const typeB = b.dataset.slideType || 'day_banner';
        if (typeA === 'day_banner' && typeB === 'default') return -1;
        if (typeA === 'default' && typeB === 'day_banner') return 1;
        return 0;
      });

      allSlides.forEach(b => {
        const shown = activeSlides.includes(b);
        b.classList.toggle('is-hidden', !shown);
        if (shown) {
          b.querySelectorAll('img').forEach(img => {
            img.loading = 'eager';
            img.fetchPriority = 'high';
          });
        }
      });

      if (track) {
        activeSlides.forEach(s => track.appendChild(s));
      }

      currentIndex = 0;
      renderDots();
      updateCarousel();
    }

    const nextSlide = () => {
      if (activeSlides.length < 2) return;
      currentIndex = (currentIndex + 1) % activeSlides.length;
      updateCarousel();
    };

    const prevSlide = () => {
      if (activeSlides.length < 2) return;
      currentIndex = (currentIndex - 1 + activeSlides.length) % activeSlides.length;
      updateCarousel();
    };

    const startAutoplay = () => {
      stopAutoplay();
      autoPlayTimer = window.setInterval(nextSlide, 5000);
    };

    const stopAutoplay = () => {
      if (autoPlayTimer) window.clearInterval(autoPlayTimer);
      autoPlayTimer = null;
    };

    const resetAutoplay = () => {
      startAutoplay();
    };

    if (nextBtn) nextBtn.addEventListener('click', () => { nextSlide(); resetAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', () => { prevSlide(); resetAutoplay(); });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    refresh();
    startAutoplay();

    const controller = {
      select(p) { previewPhase = p; refresh(); },
      deselect() { previewPhase = null; refresh(); },
      destroy() {
        stopAutoplay();
        instances.delete(root);
      }
    };
    instances.set(root, controller);
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches(selector)) install(scope);
    scope.querySelectorAll(selector).forEach(install);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  else initializeAll(document);

  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const roots = event.target.matches?.(selector) ? [event.target] : [...event.target.querySelectorAll(selector)];
    roots.forEach(root => instances.get(root)?.destroy());
  });
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest?.('[data-pd-slider-slide]');
    const root = slide?.closest(selector);
    if (root && instances.has(root)) instances.get(root).select(slide.dataset.phase);
  });
  document.addEventListener('shopify:block:deselect', event => {
    const root = event.target.closest?.(selector);
    if (root && instances.has(root)) instances.get(root).deselect();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purely-desi-honey-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.PDHoneyBanner) {
    document.querySelectorAll('[data-pdh-banner]').forEach(window.PDHoneyBanner.init);
    return;
  }
  function init(root) {
    if (!root || root.pdhCleanup) return;
    const q = selector => root.querySelector(selector);
    const picks = Array.from(root.querySelectorAll('[data-pdh-pick]'));
    const rail = q('[data-pdh-products]');
    const traveller = q('[data-pdh-traveller]');
    const carried = q('[data-pdh-carried]');
    const speech = q('[data-pdh-speech]');
    const message = q('[data-pdh-message]');
    const confetti = q('[data-pdh-confetti]');
    const pauseButton = q('[data-pdh-pause]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const on = (node, type, fn) => node?.addEventListener(type, fn, { signal: controller.signal });
    const animations = new Set();
    const timers = new Set();
    let paused = reduced.matches;
    let destroyed = false;
    let journey = null;
    let deliveryToken = 0;
    let greetingToken = 0;
    let selected = picks[0];
    let observer;
    let resizeObserver;
    const later = (fn, time) => { const id = setTimeout(() => { timers.delete(id); if (!destroyed) fn(); }, time); timers.add(id); return id; };
    const announce = text => { q('[data-pdh-announcement]').textContent = text; };
    function updateArrows() {
      if (!rail) return;
      const overflow = rail.scrollWidth - rail.clientWidth > 5;
      q('[data-pdh-scroll-controls]').hidden = !overflow;
      q('[data-pdh-prev]').disabled = rail.scrollLeft <= 3;
      q('[data-pdh-next]').disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
    }
    function clearParticles() {
      animations.forEach(animation => animation.cancel());
      animations.clear();
      confetti.replaceChildren();
    }
    function burst() {
      if (paused || document.hidden || !Element.prototype.animate) return;
      clearParticles();
      for (let i = 0; i < 26; i++) {
        const dot = document.createElement('i');
        dot.style.background = ['#f3c46b', '#ffdf9d', '#e58f4a'][i % 3];
        confetti.appendChild(dot);
        const x = (Math.random() - .5) * 340;
        const y = -70 - Math.random() * 130;
        const animation = dot.animate([
          { transform: 'translate(0,0) rotate(0)', opacity: 1 },
          { transform: `translate(${x * .7}px,${y}px) rotate(100deg)`, opacity: 1, offset: .45 },
          { transform: `translate(${x}px,130px) rotate(280deg)`, opacity: 0 }
        ], { duration: 1700 + Math.random() * 700, easing: 'cubic-bezier(.2,.6,.4,1)' });
        animations.add(animation);
        animation.finished.then(() => { animations.delete(animation); dot.remove(); }).catch(() => {});
      }
    }
    function greet() {
      const token = ++greetingToken;
      message.classList.add('is-visible');
      speech.classList.add('is-visible');
      announce('Ganpati Bappa Morya! Wishing you a joyful Ganesh Utsav.');
      burst();
      later(() => { if (token === greetingToken) { message.classList.remove('is-visible'); speech.classList.remove('is-visible'); } }, 3200);
    }
    async function deliver(initial = false) {
      const token = ++deliveryToken;
      journey?.cancel(); journey = null;
      root.classList.remove('is-delivering');
      speech.classList.remove('is-visible');
      if (paused || document.hidden || !traveller.animate) return;
      root.classList.add('is-delivering');
      journey = traveller.animate([
        { transform: 'translateX(-180px)', opacity: 0 },
        { transform: 'translateX(-140px)', opacity: 1, offset: .16 },
        { transform: 'translateX(0)', opacity: 1 }
      ], { duration: initial ? 2400 : 1900, easing: 'linear' });
      try { await journey.finished; } catch { return; }
      if (destroyed || token !== deliveryToken) return;
      journey = null;
      root.classList.remove('is-delivering');
      speech.classList.add('is-visible');
      later(() => { if (token === deliveryToken) speech.classList.remove('is-visible'); }, 2600);
    }
    function choose(pick) {
      selected = pick;
      picks.forEach(item => { const active = item === pick; item.classList.toggle('is-selected', active); item.setAttribute('aria-pressed', String(active)); });
      q('[data-pdh-title]').textContent = pick.dataset.pdhTitle;
      q('[data-pdh-shop]').href = pick.dataset.pdhUrl;
      const src = pick.dataset.pdhImage;
      carried.hidden = !src;
      q('[data-pdh-jar]').hidden = Boolean(src);
      if (src) carried.src = src; else carried.removeAttribute('src');
      announce(`Mushak brings ${pick.dataset.pdhTitle}. Use Shop this honey to see sizes and details.`);
      deliver();
    }
    function syncMotion() {
      root.classList.toggle('is-paused', paused);
      pauseButton.setAttribute('aria-pressed', String(paused));
      pauseButton.textContent = paused ? 'Play animation' : 'Pause animation';
      if (paused) { ++deliveryToken; journey?.cancel(); journey = null; root.classList.remove('is-delivering'); clearParticles(); }
    }
    picks.forEach(pick => {
      pick.setAttribute('role', 'button');
      pick.setAttribute('aria-pressed', String(pick === selected));
      pick.setAttribute('aria-label', `Let Mushak bring ${pick.dataset.pdhTitle}`);
      on(pick, 'click', event => { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); choose(pick); });
      on(pick, 'keydown', event => { if (event.key === ' ') { event.preventDefault(); choose(pick); } });
    });
    on(carried, 'error', () => { carried.hidden = true; q('[data-pdh-jar]').hidden = false; });
    on(q('[data-pdh-mushak]'), 'click', greet);
    on(q('[data-pdh-celebrate]'), 'click', greet);
    on(pauseButton, 'click', () => { paused = !paused; syncMotion(); if (!paused) deliver(); });
    on(reduced, 'change', event => { paused = event.matches; syncMotion(); });
    on(q('[data-pdh-prev]'), 'click', () => rail?.scrollBy({ left: -rail.clientWidth * .75, behavior: paused ? 'auto' : 'smooth' }));
    on(q('[data-pdh-next]'), 'click', () => rail?.scrollBy({ left: rail.clientWidth * .75, behavior: paused ? 'auto' : 'smooth' }));
    on(rail, 'scroll', updateArrows);
    on(document, 'visibilitychange', () => { if (journey && !paused) document.hidden ? journey.pause() : journey.play(); if (document.hidden) clearParticles(); });
    if ('ResizeObserver' in window && rail) { resizeObserver = new ResizeObserver(updateArrows); resizeObserver.observe(rail); } else on(window, 'resize', updateArrows);
    pauseButton.hidden = false;
    q('[data-pdh-celebrate]').hidden = false;
    if (picks.length) q('[data-pdh-choice-hint]').hidden = false;
    syncMotion(); updateArrows();
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); if (!destroyed) deliver(true); } }, { threshold: .2 });
      observer.observe(root);
    } else deliver(true);
    root.pdhCleanup = () => {
      destroyed = true; controller.abort(); observer?.disconnect(); resizeObserver?.disconnect();
      journey?.cancel(); clearParticles(); timers.forEach(clearTimeout); timers.clear();
      delete root.pdhCleanup;
    };
  }
  window.PDHoneyBanner = { init };
  document.querySelectorAll('[data-pdh-banner]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pdh-banner]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-pdh-banner]').forEach(root => root.pdhCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();
})();
